import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../../widgets/form/InputSelectSF'

const NachUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  // form fields
  nach, onNachChange, setNachError, booleanList, nachError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update women Nach'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputSelectSF 
      type='text' 
      name='nach_transfer' 
      label='Nach Transfer' 
      value={nach} 
      onChange={onNachChange} 
      optionList={booleanList}
      error={nachError} 
      setError={setNachError}
    />
  </ModalFormUI>

export default NachUpdateModalUI
